const { required, minLength, email } =  require('vuelidate/lib/validators');
import { TheMask } from 'vue-the-mask'

export default {
    name: 'appContact',
    components: {
        TheMask
    },
    data() {
        return {
            user: {
                name: '',
                email: '',
                phone: '',
                message: '',
                source: 'ceibas'
            },
            sent: false
        }
    },
    validations: {
        user: {
            name: { required, minLength: minLength(4) },
            email: { required, email },
            phone: { required },
            message: {  }
        }
    },
    methods: {
        submit: async function () {
            let response = await this.$axiosCall('POST', '/index/contact', this.user, null, false);
            if(response.status === 200) await this.$router.push('/thanks')
        }
    }
}
